<template>
    <div>
        <b-modal ref="booking" id="booking" @close="handleReset" @hide="closing" @ok.prevent="cancelBooking" @cancel.prevent="handleReset" :title="modalTitle" size="xl" centered :visible=" ! loading" cancel-title="Keep Booking" ok-title="Cancel Booking" :ok-disabled="loading || processing">
            <template v-if="booking && game">
                <b-row>
                    <b-col>
                        <p>Do you want to cancel your booking for the game on {{ gameDate }}</p>
                        <table class="table table-striped table-sm">
                            <thead>
                                <tr>
                                    <th>item</th>
                                    <th>Price</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Game Fee</td>
                                    <td>£{{ (booking.price / 100).toFixed(2) }}</td>
                                </tr>

                                <template v-if="booking.rentals.length > 0">
                                    <tr>
                                        <td colspan="2">Rentals</td>
                                    </tr>
                                    <tr v-for="rental in booking.rentals" :key="rental.id">
                                        <td>{{ rental.rental_type.name }}</td>
                                        <td>£{{ (rental.rental_type.price / 100).toFixed(2) }}</td>
                                    </tr>
                                </template>
                            </tbody>

                            <tfoot>
                                <tr>
                                    <td colspan="2" class="text-right">Total £{{ (totalPrice / 100).toFixed(2) }}</td>
                                </tr>
                            </tfoot>
                        </table>
                    </b-col>
                </b-row>
            </template>
        </b-modal>
    </div>
</template>

<script>
import moment from 'moment-timezone';

export default {
    props: {
        bookingId: {
            default: false,
        },
        memberId: {
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            processing: false,
            booking: false,
            processingStage: false,
            game: false,
        }
    },
    computed: {
        modalTitle() {
            return this.game ? (this.game.title) ? this.game.title + ' ' + this.gameDate : this.gameDate : 'Game Booking';
        },
        gameDate() {
            if ( ! this.game) {
                return '';
            }
            return moment(this.game.start_time).tz('Europe/London').format('ddd Do MMM YYYY HH:mm');
        },
        totalPrice() {
            let total = this.booking.price;

            // Iterate over rentals on the booking and add their price based on the rental type which is attached to the rental
            // The price is stored in the following key booking.rentals[].rentalType.price
            this.booking.rentals.forEach((rental) => {
                total += rental.rental_type.price;
            });

            return total;
        },
    },
    methods: {
        cancelBooking() {
            // bookings.cancel
            this.processing = true;
            axios.delete(this.$routes.route('bookings.cancel', {booking: this.bookingId}))
                .then((response) => {
                    this.processing = false;
                    this.handleReset();
                })
                .catch((error) => {
                    this.processing = false;
                    console.error(error);
                });
        },
        handleReset() {
            this.loading = false;
            this.processing = false;
            this.processingStage = false;
            this.booking = false;
            this.game = false;
            this.$emit('closing');
        },
        closing() {},
        init() {
            axios.get(this.$routes.route('bookings.booking', {booking: this.bookingId}))
                .then((response) => {
                    this.booking = response.data;
                    this.game = this.booking.game;
                    this.loading = false;
                })
                .catch((error) => {
                    this.loading = false;
                    console.error(error);
                });
        },
    },
    mounted() {
        this.loading = true;
        this.init();
    },
}
</script>